/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Problems_OverlineInputs */

const en_mk_sol_problems_overline = /** @type {(inputs: Mk_Sol_Problems_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where it usually jams`)
};

const id_mk_sol_problems_overline = /** @type {(inputs: Mk_Sol_Problems_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang biasanya macet`)
};

/**
* | output |
* | --- |
* | "Where it usually jams" |
*
* @param {Mk_Sol_Problems_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_problems_overline = /** @type {((inputs?: Mk_Sol_Problems_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Problems_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_problems_overline(inputs)
	return en_mk_sol_problems_overline(inputs)
});